// pages/VerifyPage.js
import React, { useEffect } from 'react';
import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { useDispatch } from 'react-redux';
import { setAuthenticated } from '../../features/auth/authSlice';
import { useNavigate } from 'react-router-dom';
import { createUser } from '../../features/user/userSlice'
import { setUser, loginotp } from '../../features/auth/authSlice'
import { toast } from 'react-toastify';
import { serializeUser } from '../../features/auth/serializeUser';

function VerifyEmail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const url = window.location.href;
    const email = window.localStorage.getItem('emailForSignIn') || window.prompt("E-postanızı girin:");

    if (isSignInWithEmailLink(auth, url)) {
      signInWithEmailLink(auth, email, url)
        .then((result) => {
            // User signed in successfully.
            let user = result.user;
            console.log(user);

            const safeUser = serializeUser(user);

            if (safeUser) {
              localStorage.setItem('user', JSON.stringify(safeUser))
            }

            dispatch(setUser(safeUser));
            dispatch(loginotp(safeUser));

            if (user.metadata.creationTime === user.metadata.lastSignInTime) {
              dispatch(createUser(safeUser));
              navigate('/MyProfile');
              console.log('Bu kullanıcı ilk defa giriş yaptı.');
            } else {
              console.log('Bu kullanıcı daha önce giriş yapmıştır.');
              //navigate(from);
              navigate('/dashboard');
            }

            toast.success("Giriş başarılı");

            // Kullanıcı meta bilgileri
            //const createdAt = user.metadata.createdAt;
            //const lastLoginAt = user.metadata.lastLoginAt;

            // createdAt ile lastLoginAt aynıysa yeni kullanıcıdır
            //const isNewUser = createdAt === lastLoginAt;

            //console.log("Kullanıcı ID:", user.uid);
            //console.log("Yeni kullanıcı mı?", isNewUser);

            //dispatch(setAuthenticated({ isNewUser }));
            
            /*
            if (isNewUser) {
                dispatch(createUser(user));
                navigate('/MyProfile');
                console.log('Bu kullanıcı ilk defa giriş yaptı.');
            } else {
                console.log('Bu kullanıcı daha önce giriş yapmıştır.');
                navigate('/dashboard');
            }
            */

            window.localStorage.removeItem('emailForSignIn');
          
        })
        .catch((error) => {
            console.error("Giriş doğrulanamadı:", error);
            alert("Giriş doğrulanamadı.");
        });
    }
  }, [dispatch, navigate]);

  return <div>Giriş Doğrulanıyor...</div>;
}

export default VerifyEmail;
